require.register("documenteditor/controllers/archivnrsCtrl", function(exports, require, module){
  $0
  
});

